// extracted by mini-css-extract-plugin
module.exports = {"tabGrid":"gallery_tabGrid__QH_n9","quote":"gallery_quote__jMkMj","horizontalQuote":"gallery_horizontalQuote__ks9Sr"};